module.exports = __webpack_public_path__ + "static/media/heart27.687623d8.svg";